// Shared display topology. Bounds are schematic faces, not manufacturing cuts;
// actual cut sizes and joints always come from the backend production pieces.
export function gridMullions(xEdges:number[],yEdges:number[],frameInset:number,mullionWidth:number) {
  const members:Array<{x:number;y:number;width:number;height:number;location:string}>=[];
  const width=xEdges.at(-1)??0,height=yEdges.at(-1)??0;
  for(let col=1;col<xEdges.length-1;col++)members.push({x:xEdges[col]-mullionWidth/2,y:frameInset,width:mullionWidth,height:height-2*frameInset,location:`Импост ${col}`});
  for(let row=1;row<yEdges.length-1;row++)for(let col=0;col<xEdges.length-1;col++){
    const left=col===0?frameInset:xEdges[col]+mullionWidth/2;
    const right=col===xEdges.length-2?width-frameInset:xEdges[col+1]-mullionWidth/2;
    members.push({x:left,y:yEdges[row]-mullionWidth/2,width:right-left,height:mullionWidth,
      location:xEdges.length===2?`Горизонтальный импост ${row}`:`Горизонтальный импост ${row} · секция ${col+1}`});
  }
  return members;
}
